<template>
  <div class="currency_boxs">
    <div class="curriculum_top">
      <div class="curriculum_title">
        实操基地活动回顾
        <!-- <span style="margin-left:20px;font-size:14px">介绍内容</span>
          <span class="tabItem"
                v-for="h in 6"
                :key="h +'h'">{{h}}</span> -->
      </div>
      <!-- <div>更多</div> -->
    </div>
    <el-carousel indicator-position="outside"
                 style="width:100%"
                 arrow="never"
                 height="840px">
      <el-carousel-item v-for="x in 2"
                        :key="x+'x'">
        <div class="moment_list">
          <div v-for="(item,index) in list"
               @mouseenter="mouseover(index)"
               @mouseleave="mouseout"
               class="moment_item"
               :key="item">
            <div class="img">
              <el-image class="dong"
                        style="width:100%; height: 244px;border-radius: 10px 10px 0 0;"
                        :src="item.url"></el-image>
            </div>
            <div class="curriculum_item_box">
              <div class="curriculum_item_title font18">陈列实操，提销策略——商品陈列与销售 提升实操班</div>
              <div class="lecturer">学练一体、卖场实操、经验传输、思想同频，帮助企 业提升业绩10%</div>
              <div class="flexStart mainColor font14"
                   style="margin-top:24px">
                查看课程详情<i class="el-icon-arrow-right"></i><i class="el-icon-arrow-right"></i>
              </div>
            </div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>
<script>
export default {
  data () {
    return {
      activeIndex: -1,
      list: [
        { url: 'https://img0.baidu.com/it/u=2266992387,3653937162&fm=253&fmt=auto&app=138&f=JPEG?w=346&h=500', bg: 'linear-gradient(90deg, #1f8ffb, #0f54ec)' },
        { url: 'https://img2.baidu.com/it/u=1318432244,4009299303&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=711', bg: 'linear-gradient(90deg, #19CEAD, #00B292)' },
        { url: 'https://img2.baidu.com/it/u=2616025538,1484344267&fm=253&fmt=auto&app=138&f=JPEG?w=333&h=500', bg: 'linear-gradient(90deg, #FA6992, #EA2B61)' },
        { url: 'https://img2.baidu.com/it/u=154933639,2780893441&fm=253&fmt=auto&app=138&f=JPEG?w=392&h=500', bg: 'linear-gradient(90deg, #50D6BE, #4180F5)' },
        { url: 'https://img2.baidu.com/it/u=154933639,2780893441&fm=253&fmt=auto&app=138&f=JPEG?w=392&h=500', bg: 'linear-gradient(90deg, #50D6BE, #4180F5)' },
        { url: 'https://img2.baidu.com/it/u=1318432244,4009299303&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=711', bg: 'linear-gradient(90deg, #19CEAD, #00B292)' },
      ]

    }
  },
  methods: {
    mouseover (index) {
      this.activeIndex = index
    },
    mouseout () {
      this.activeIndex = -1
    }
  }
}
</script>
<style lang="less" scoped>
.curriculum_top {
  display: flex;
  .curriculum_title {
    flex: 1;
    .tabItem {
      display: inline-block;
      margin: 0 20px;
    }
  }
}
.moment_list {
  // display: flex;
  width: 100%;
  margin-top: 20px;
  .moment_item {
    display: inline-block;
    width: calc((100% - 60px) / 3);
    // height: 175px;
    background-color: #fff;
    border-radius: 10px;
    margin-right: 30px;
    margin-bottom: 30px;
    .img {
      width: 100%;
      height: 244px;
      overflow: hidden;
      .dong {
        transition: all 2s;
      }
      .dong:hover {
        transform: scale(1.5);
        border-radius: 10px 10px 0 0;
      }
    }
    .curriculum_item_box {
      padding: 20px 10px;
      // border-radius: 0 0 10px 10px;
      box-sizing: border-box;
      .lecturer {
        color: #666666;
        font-size: 12px;
      }
      .curriculum_item_center {
        display: flex;
        margin: 15px 0;
        .l {
          background-color: #f2f4f7;
          color: '#333333';
          font-size: 12px;
          padding: 6px 8px;
          box-sizing: border-box;
          border-radius: 12px;
          margin-right: 10px;
        }
      }
      .curriculum_item_title {
        overflow: hidden;
        display: -webkit-box;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        white-space: normal;
        font-size: 14px;
        color: #333;
        font-weight: bold;
      }
    }
  }

  .moment_item:nth-child(3) {
    margin-right: 0;
  }
  .moment_item:nth-child(6) {
    margin-right: 0;
  }
}
</style>